import { render, staticRenderFns } from "./d-upvotes-modal.vue?vue&type=template&id=28ea3b1e&scoped=true&"
import script from "./d-upvotes-modal.vue?vue&type=script&lang=js&"
export * from "./d-upvotes-modal.vue?vue&type=script&lang=js&"
import style0 from "./d-upvotes-modal.vue?vue&type=style&index=0&id=28ea3b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ea3b1e",
  null
  
)

export default component.exports